import React from 'react';
import { Row, Col } from 'react-bootstrap';
import ChooseLedmodule from './ChooseLedmodule';
import RecentLedmodules from './RecentLedmodules';
import ProductsNews from './ProductsNews';

class Welcome extends React.Component {

    render() {
        return (
            <Row style={{ height: '100%', marginLeft: '0', marginRight: '0' }}>
                <Col sm={4} className="col-welcome">
                    <ChooseLedmodule />
                </Col>
                <Col sm={4} className="col-welcome">
                    <RecentLedmodules />
                </Col>
                <Col sm={4} className="col-welcome">
                    <ProductsNews />
                </Col>
            </Row>
        );
    }
};

export default Welcome;